import { batch } from "react-redux";
import { get } from "lodash";
import BetUtils from "@tvg/utils/betSelectionUtils";
import {
  setBetAmount,
  setBetType,
  setSelectionRequest,
  setStartBetting
} from "@tvg/desktop-bet/src/store/actions";
import { Dispatch } from "redux";
import {
  BettingInterest,
  RaceOdds,
  RaceProgram,
  RaceWagerType
} from "@tvg/ts-types/Race";

export const changeBetType = (
  wager: RaceWagerType,
  dispatch: Dispatch,
  userAccountNumber: string,
  MinimalBetAmount: boolean,
  BetAmountPreference: { [key: string]: number }
) => {
  // TODO not completed we will revisit this later
  const betAmount = BetUtils.getBetAmount(
    wager,
    userAccountNumber,
    MinimalBetAmount,
    BetAmountPreference
  );
  const selections = BetUtils.setMatrixSizeByLegCount(
    get(wager, "columnCount", 1)
  );
  batch(() => {
    // do not reset selection for win group
    if (get(wager, "group.id", 0) !== 10) {
      dispatch(setSelectionRequest(selections));
    }
    dispatch(setBetType(get(wager, "type.code", "")));
    dispatch(setBetAmount(betAmount));
    dispatch(setStartBetting(true));
  });
};

const isFavoriteBIScratched = (bettingInterests: BettingInterest[]) => {
  for (let i = 0; i < bettingInterests.length; i += 1) {
    if (bettingInterests[i].favorite) {
      const { runners } = bettingInterests[i];

      for (let j = 0; j < runners.length; j += 1) {
        if (!runners[j].scratched) {
          return false;
        }
      }
    }
  }
  return true;
};

export const oddCalculation = ({ numerator, denominator }: RaceOdds) =>
  denominator ? Number(numerator) / denominator : numerator;

export const getLowestOdd = (bettingInterests: BettingInterest[]): number =>
  bettingInterests.reduce(
    (lowestOdd: number, bi: BettingInterest) =>
      bi?.currentOdds && !bi.runners.every((runner) => runner.scratched)
        ? Math.min(
            bi?.currentOdds
              ? oddCalculation(bi?.currentOdds) || Number.MAX_VALUE
              : Number.MAX_VALUE,
            lowestOdd
          )
        : lowestOdd,
    Number.MAX_VALUE
  );

export const calculateFavoriteRunner = (
  raceWithBettingInterests: RaceProgram
) => {
  let lowestOdd = Number.MIN_VALUE;
  const bettingInterests = raceWithBettingInterests?.bettingInterests || [];
  if (!bettingInterests.length) {
    return raceWithBettingInterests;
  }

  const useLowestOddFavorite = isFavoriteBIScratched(bettingInterests);

  if (useLowestOddFavorite) {
    lowestOdd = getLowestOdd(bettingInterests);
  }

  return {
    ...raceWithBettingInterests,
    bettingInterests: (raceWithBettingInterests.bettingInterests || []).map(
      (bi) => {
        const isFavorite =
          useLowestOddFavorite && bi?.currentOdds
            ? oddCalculation(bi?.currentOdds) === lowestOdd
            : bi?.favorite;

        return {
          ...bi,
          favorite: bi?.currentOdds ? isFavorite : false
        };
      }
    )
  };
};

export const selectRunner = (dispatch: Dispatch) => {
  // TODO
  batch(() => {
    // do not reset selection for win group
    dispatch(setStartBetting(true));
  });
  // activate betting
  // group 10 do not delete selection
  // atomic actions
};

export const removeScratched = () => {
  // TODO
  // if you have selection remove scratched and inform user
  // atomic actions
};

export default {
  changeBetType,
  selectRunner,
  removeScratched
};
